import { useLanguage } from "../contexts/LanguageContext";

function Skills({skills}) {
  const { t } = useLanguage();
  return (
    <section id="skills" className="py-24">
      <h2 className="text-4xl font-bold text-center mb-12 bg-clip-text text-transparent bg-gradient-to-r from-purple-500 to-cyan-500 animate-fade-in leading-tight">
        {t('whatICanDo')}
      </h2>
      <div className="flex flex-wrap justify-center gap-4">
        {skills.map((skill, index) => (
          <div
            key={index}
            className="px-6 py-3 bg-gray-800/50 border border-white/10 rounded-full text-lg text-gray-300 transition-all duration-300 hover:border-purple-500/50 hover:text-white hover:shadow-md hover:shadow-purple-500/20 animate-fade-in"
            style={{ animationDelay: `${100 + index * 100}ms` }}
          >
            {skill}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;